export default __webpack_public_path__ + "static/1181-584738792d747240f2b66409b8f773f1.gif";